import { ModuleWithProviders, NgModule } from '@angular/core';

import { SettingsService } from '../services/settings';
import { ExternalDependencyLoader } from './external-dependency-loader.service';
import { LoaderService } from './loader.service';
import { ServiceProxy } from './service-proxy.service';

@NgModule()
export class ServicesModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ServicesModule,
      providers: [
        ExternalDependencyLoader,
        LoaderService,
        ServiceProxy,
        SettingsService
      ]
    };
  }
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/services/services.module.ts